<template>
  <div ref="Robot" id="Robot" class="robot_animate_wrap">
    <video
        class="bg_video"
        :style="{width: `${defaultWidth}px`, height: `${defaultHeight}px`}"
        autoplay
        muted
        loop
    >
      <source :src="robotVideoBg" type="video/webm">
    </video>
    <div class="date_text_wrap">
      <div class="time_label">{{nowDateTimeObj.obj.time}}</div>
      <div class="month_label">{{nowDateTimeObj.obj.date}}</div>
      <div class="year_label">{{nowDateTimeObj.obj.y}}</div>
    </div>
    <div class="cpu_temp_type_wrap">{{nowCpuTemp.type_label}}</div>
    <div class="cpu_temp_value_wrap">{{nowCpuTemp.value_label}}</div>
    <div class="cpu_temp_unit_wrap">{{nowCpuTemp.Unit}}</div>

    <div class="gpu_temp_wrap">
      <div class="type_label">{{nowGpuTemp.type_label}}</div>
      <div class="value_wrap">
        <span class="value_label">{{nowGpuTemp.value_label}}</span>
        <span class="unit_label">{{nowGpuTemp.Unit}}</span>
      </div>
    </div>
    <div class="ram_wrap">
      <div class="type_label">{{nowRam.type_label}}</div>
      <div class="value_label">{{nowRam.value_label}}</div>
      <div class="unit_label">{{nowRam.Unit}}</div>
    </div>
  </div>
</template>

<script setup>
import moment from "moment"

import robotVideoBg from '@/assets/robot/robot_video_bg.webm'
import {onMounted, onUnmounted, reactive, ref, watch} from 'vue'
import defaultValue from "@/utils/defaultValue"
const {defaultWidth, defaultHeight} = defaultValue()

const props = defineProps(['sensorValue'])
const nowCpuTemp = reactive({
  type_label: 'CPU TEMP',
  value_label: '--',
  Unit: '°F'
})
const nowGpuTemp = reactive({
  type_label: 'GPU TEMP',
  value_label: '--',
  Unit: '°F'
})
const nowRam = reactive({
  type_label: 'RAM',
  value_label: '--',
  Unit: '%'
})

let nowDateTimeObj = reactive({obj: {}})
let timeTiger = ref(null)
const startTime = () => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
  const nowDate = moment().format('YYYY,MM/DD,HH:mm').split(',')
  const timeTextObj = {
    y: nowDate[0],
    date: nowDate[1], // 月日
    time: nowDate[2], // 時間
  }
  nowDateTimeObj.obj = timeTextObj
  timeTiger.value = setTimeout(function () {
    startTime()
  }, 150)
}


watch(
    props.sensorValue,
    (n) => {
      if (n) {
        const {CPUTemperature, GPUTemperature, RAM} = n
        if (CPUTemperature && Object.keys(CPUTemperature).length > 0) {
          Object.assign(nowCpuTemp, CPUTemperature, {
            type_label: `${CPUTemperature.Type} ${CPUTemperature.Label}`,
            value_label: parseInt(CPUTemperature.Value) > 0 ? CPUTemperature.Value : '--'
          })
        }
        if (GPUTemperature && Object.keys(GPUTemperature).length > 0) {
          Object.assign(nowGpuTemp, GPUTemperature, {
            type_label: `${GPUTemperature.Type} ${GPUTemperature.Label}`,
            value_label: parseInt(GPUTemperature.Value) > 0 ? GPUTemperature.Value : '--'
          })
        }
        if (RAM && Object.keys(RAM).length > 0) {
          Object.assign(nowRam, RAM, {
            type_label: `${RAM.Type}`,
            value_label: parseInt(RAM.Value) > 0 ? RAM.Value : '--'
          })
        }
      }
    },
    {immediate: true}
)

onMounted(() => {
  startTime()
})

onUnmounted(() => {
  if (timeTiger.value) clearTimeout(timeTiger.value)
})


</script>

<style lang="scss">
@import "src/assets/scss/font-family";

.robot_animate_wrap {
  position: relative;
  .bg_video {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .date_text_wrap {
    position: absolute;
    top: 187px;
    left: 89px;
    font-family: HyperspaceRace_BoldItalic;
    width: 90px;
    .time_label {
      font-size: 39px;
      color: #F5F5F5;
      text-align: center;
      line-height: 1;
      text-shadow: 0 0 6px #000;
    }
    .month_label, .year_label {
      font-size: 24px;
      color: #FE4628;
      text-align: center;
      line-height: 1;
      text-shadow: 3px 3px 99px rgba(0,0,0,16);
    }
  }
  .cpu_temp_type_wrap {
    position: absolute;
    font-family: HyperspaceRace_BoldItalic;
    top: 61px;
    left: 309px;
    color: #FE4628;
    font-size: 19px;
    text-align: center;
    line-height: 1;
    width: 120px;
    text-shadow: 0 0 6px #000029;
  }
  .cpu_temp_value_wrap {
    position: absolute;
    font-family: HyperspaceRace_BoldItalic;
    top: 68px;
    left: 302px;
    color: #F5F5F5;
    font-size: 84px;
    text-align: center;
    line-height: 1;
    width: 128px;
  }
  .cpu_temp_unit_wrap {
    position: absolute;
    font-family: HyperspaceRace_BoldItalic;
    top: 153px;
    left: 350px;
    color: #F5F5F5;
    font-size: 35px;
    text-align: center;
    line-height: 1;
  }

  .gpu_temp_wrap {
    position: absolute;
    font-family: HyperspaceRace_BoldItalic;
    top: 351px;
    left: 30px;
    .type_label {
      color: #F9EDC5;
      font-size: 20px;
      line-height: 1;
      margin-bottom: -6px;
      text-align: left;
    }
    .value_wrap {
      display: inline-block;
      width: 170px;
    }
    .value_label {
      display: inline-block;
      width: 130px;
      color: #F5F5F5;
      font-size: 90px;
      text-align: center;
      line-height: 1;
    }
    .unit_label {
      color: #F5F5F5;
      font-size: 35px;
      text-align: center;
      line-height: 1;
    }
  }
  .ram_wrap {
    position: absolute;
    font-family: HyperspaceRace_BoldItalic;
    top: 319px;
    left: 324px;
    width: 96px;
    .type_label {
      color: #FAECB8;
      font-size: 26px;
      text-align: center;
      line-height: 1;
      margin-bottom: 6px;
    }
    .value_label {
      width: 96px;
      color: #FFF;
      font-size: 64px;
      text-align: center;
      line-height: 1;
      text-shadow: 0 0 3px #FFF;
    }
    .unit_label {
      color: #F5F5F5;
      font-size: 35px;
      text-align: center;
      line-height: 1;
      margin-top: -4px;
    }
  }

}
</style>
